import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { SiteProvider } from "./context/SiteContext";
import PublicLayout from "./pages/PublicLayout";
import Home from "./pages/Home";
import ServicesPage from "./pages/ServicesPage";
import ReviewsPage from "./pages/ReviewsPage";
import ContactPage from "./pages/ContactPage";
import AuthPage, { QuotePage, ForgotPassword, ResetPassword } from "./pages/AuthPage";
import DashboardLayout, { RoleGate } from "./dashboard/DashboardLayout";
import Overview from "./dashboard/Overview";
import Quotations from "./dashboard/Quotations";
import Orders from "./dashboard/Orders";
import Chat from "./dashboard/Chat";
import Announcements from "./dashboard/Announcements";
import { Notifications, Profile } from "./dashboard/Account";
import People from "./dashboard/admin/People";
import ContentManager from "./dashboard/admin/Content";
import { ReviewsAdmin, VideosAdmin, FaqsAdmin } from "./dashboard/admin/Collections";
import { Inquiries, SettingsPage } from "./dashboard/admin/Misc";

function ScrollTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) document.querySelector(hash)?.scrollIntoView();
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

const A = ({ children }) => <RoleGate roles={["admin"]}>{children}</RoleGate>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SiteProvider>
          <BrowserRouter>
            <ScrollTop />
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Navigate to="/" replace />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/services/:slug" element={<ServicesPage />} />
                <Route path="/reviews" element={<ReviewsPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/quote" element={<QuotePage />} />
                <Route path="/login" element={<AuthPage />} />
                <Route path="/register" element={<AuthPage />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
              </Route>
              <Route path="/dashboard" element={<DashboardLayout />}>
                <Route index element={<Overview />} />
                <Route path="quotations" element={<RoleGate roles={["admin", "customer"]}><Quotations /></RoleGate>} />
                <Route path="orders" element={<Orders />} />
                <Route path="progress" element={<RoleGate roles={["grinder"]}><Orders progressOnly /></RoleGate>} />
                <Route path="messages" element={<Chat type="direct" />} />
                <Route path="groups" element={<Chat type="group" />} />
                <Route path="announcements" element={<Announcements />} />
                <Route path="notifications" element={<Notifications />} />
                <Route path="profile" element={<Profile />} />
                <Route path="customers" element={<A><People role="customer" /></A>} />
                <Route path="grinders" element={<A><People role="grinder" /></A>} />
                <Route path="inquiries" element={<A><Inquiries /></A>} />
                <Route path="content" element={<A><ContentManager /></A>} />
                <Route path="reviews" element={<A><ReviewsAdmin /></A>} />
                <Route path="videos" element={<A><VideosAdmin /></A>} />
                <Route path="faqs" element={<A><FaqsAdmin /></A>} />
                <Route path="settings" element={<A><SettingsPage /></A>} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
        </SiteProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
